import React from 'react';
import { BlogsStateData } from 'core/redux/features/blogs';
import { ImageLoading, TextLoading } from '../../../Components/Loaders';

export const Item = (props: {
  href?: string;
  item?: BlogsStateData;
  deviceType?: string;
}) => {
  const { href, item } = props;

  let image = item?.image;
  if (image && !image.startsWith('http') && !image.startsWith('/')) {
    image = '/' + image;
  }

  return (
    <div className="column is-12-mobile is-4-tablet ">
      <a className="post-link" href={href ?? '#'}>
        <div className="card card-list">
          <div className="card-image">
            {image ? (
              <div className="image is-3by2">
                <img src={image} alt={item.title} />
              </div>
            ) : (
              <ImageLoading width="100%" height={180} />
            )}
          </div>
          <div className="card-content">
            <div className="title" style={{ margin: 0 }}>
              {item?.title ?? <TextLoading height="15" />}
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
